import { Checkbox, Flex, Tooltip } from "@mantine/core";
import {
  IconPresentationAnalytics,
  IconTableShortcut,
} from "@tabler/icons-react";
import { Fragment, useCallback, useEffect } from "react";
import { DateTimeDisp } from "src/components/shared/DateTime";
import ScrollableTable from "src/components/shared/ScrollableTable/ScrollableTable";
import { type ISection } from "src/interfaces";
import { StyledActionIcon, StyledTd, StyledTr } from "src/styled";

import type { IHistoryRow } from "../HistoryModal.types";
import { useHistoryModal } from "./HistoryModal.hooks";
import { headers } from "./HistoryModal.utils";

interface Props {
  onSetSection: (section: ISection) => void;
  requestBody?: any;
  hideAutosave?: boolean;
}

const HistoryModalTable = ({
  onSetSection,
  requestBody,
  hideAutosave,
}: Props) => {
  const {
    showAutoSaves,
    toggleAutoSaves,
    autoSavesNumber,
    history,
    handleViewHistory,
    isLoading,
    refetch,
  } = useHistoryModal(requestBody, hideAutosave);
  useEffect(() => {
    void refetch();
  }, [refetch]);
  const renderRow = useCallback(
    ({ row }: { row: IHistoryRow }) => {
      const lt = row.f4 && (typeof row.f4 === "string" ? row.f4 : row.f4.date);
      const utc =
        row.f4 && (typeof row.f4 === "string" ? undefined : row.f4.dateUTC);
      return (
        <StyledTr>
          <StyledTd>
            {row.f1?.split("\n").map(el => (
              <p key={el}>{el}</p>
            ))}
          </StyledTd>
          <StyledTd center>{row.f2}</StyledTd>
          <StyledTd>{row.f3}</StyledTd>
          <StyledTd>
            <DateTimeDisp lt={lt} utc={utc} />
          </StyledTd>
          <StyledTd center>
            {row.data?.rows && (
              <Tooltip label="View deleted row">
                <StyledActionIcon
                  mx="auto"
                  onClick={() => row.data && onSetSection(row.data)}>
                  <IconTableShortcut />
                </StyledActionIcon>
              </Tooltip>
            )}
            {row.view && (
              <Tooltip label="View">
                <StyledActionIcon
                  mx="auto"
                  onClick={handleViewHistory(row.hid ?? row.cardid)}>
                  <IconPresentationAnalytics />
                </StyledActionIcon>
              </Tooltip>
            )}
          </StyledTd>
        </StyledTr>
      );
    },
    [handleViewHistory, onSetSection],
  );
  return (
    <Fragment>
      <Flex align="center" justify="flex-end" gap={20} mb="lg" pr="sm">
        {!hideAutosave && (
          <Checkbox
            labelPosition="left"
            label={`Show Auto Saves (${autoSavesNumber})`}
            checked={showAutoSaves}
            onChange={toggleAutoSaves}
          />
        )}
      </Flex>
      <ScrollableTable
        data={(history ?? []) as any}
        headers={headers}
        renderRow={renderRow}
        keyExtractor={(h, i) => h.hid ?? i}
        style={{ height: "50vh" }}
        loading={!history || isLoading}
      />
    </Fragment>
  );
};
export default HistoryModalTable;
